import { TemplateElement, html, defineElement, optionalAttribute } from '@webtides/element-js';
import style from './video.css';
import { when } from '@webtides/element-js/src/dom-parts/directives';

/**
 * @property {string} src
 * @property {string} subtitleUrl
 * @property {string} captionUrl
 * @property {boolean} autoplay
 * @property {boolean} looping
 * @property {boolean} controls
 * @property {boolean} muted
 * @property {string} posterUrl
 */
export default class Video extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            src: '', // '' || ['', ''] || [{src: '', media: ''},{src: '', media: ''}]
            subtitleUrl: '',
            captionUrl: '',
            autoplay: false,
            looping: false,
            controls: false,
            muted: false,
            posterUrl: '',
        };
    }

    template() {
        const urls = typeof this.src === 'string' ? [this.src] : this.src;
        const formattedUrls = urls.map((item) => (typeof item === 'string' ? { src: item } : item));

        return html`
            <video
                ?muted="${this.muted}"
                ?autoplay="${this.autoplay}"
                ?loop="${this.looping}"
                ?controls="${this.controls}"
                playsinline
                poster="${this.posterUrl}"
            >
                ${formattedUrls.map(
                    ({ src, media }) => html`<source src="${src}" ${optionalAttribute(media, 'media', media)} />`,
                )}
                ${when(
                    this.subtitleUrl,
                    `<track kind="subtitles" src="${this.subtitleUrl}" srclang=${document.documentElement.lang} />`,
                )}
                ${when(
                    this.captionUrl,
                    `<track kind="captions" src="${this.captionUrl}" srclang=${document.documentElement.lang} />`,
                )}
            </video>
        `;
    }
}

defineElement('mb-video', Video);
